let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("d9A3r")).then(() => parcelRequire('k2c1s'));